import * as React from 'react'
import { useTranslation } from '@disco/i18n/use-translation'
import ButtonContainer from 'components/ui/button-container'
import InlineLink from 'components/ui/inline-link'
import styles from './index.module.css'

type Props = {
  playlistUrl: string
  setDiscoPlaylist: (...args: Array<any>) => any
  changeUrlParams: {
    path: string
    groupId: string
    groupName: string
    search: string
  }
}

const DiscoPlaylistActions = ({
  playlistUrl,
  changeUrlParams: { path, groupId, groupName, search },
  setDiscoPlaylist,
}: Props): React.ReactNode => {
  const { t } = useTranslation('inboxes')

  return (
    <ButtonContainer className={styles.discoPlaylistActions}>
      <InlineLink to={playlistUrl} target="_blank" rel="noopener noreferrer">
        {t('inboxes:viewPlaylist', 'View playlist')}
      </InlineLink>
      <InlineLink
        to={{
          pathname: `/${path}/${groupId}/${groupName}/select-playlist`,
          search,
        }}
      >
        {t('inboxes:changePlaylist', 'Change playlist')}
      </InlineLink>
      <InlineLink onClick={() => setDiscoPlaylist(null)}>
        {t('inboxes:removePlaylist', 'Remove playlist')}
      </InlineLink>
    </ButtonContainer>
  )
}

export default DiscoPlaylistActions
